import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Content } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get Course lecture content
 * @param course_id
 * @param version
 * @param sectionId
 * @param lectureId
 * @param contentId
 * @param isAuthor
 * @param fetchMultiRes
 */
const getCourseLectureContent = (
  course_id: string | string[],
  version: number,
  sectionId: string,
  lectureId: string,
  contentId: string,
  isAuthor = false,
  fetchMultiRes = false
): Promise<Content> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/sections/' +
      sectionId +
      '/lectures/' +
      lectureId +
      '/contents/' +
      contentId +
      '?isAuthor=' +
      isAuthor +
      '&fetchMultiRes=' +
      fetchMultiRes
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    AxiosClient.get(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getCourseLectureContent
